import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { OnGoingAction } from "../../../components/UI/Banner/OnGoingAction";
import { closePollDrawer, closeSidebar, getUIState } from "store/UI";
import React, { Suspense } from "react";
const NewSideNav = React.lazy(() =>
  import("./Sidebar/new-side-nav").then((mod) => ({
    default: mod.NewSideNav,
  }))
);

export default function AdminLayout() {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  //useselector
  const { isOpen, isPollDrawerOpen } = useSelector(getUIState);

  //variables
  const height = window.innerHeight - 150;
  const isWorkspace = pathname === "/workspace";

  //functions
  const onClose = () => {
    dispatch(closePollDrawer());
  };

  const {
    onGoingEvent,
    eventId,
    teamId,
  } = useSelector((state) => state.onGoingActionSlice);

  return (
    <section className="relative min-h-screen">
      {onGoingEvent && (
        <OnGoingAction
          type={"Event"}
          url={`/active-event/${eventId}/${teamId}?isEvent=${true}`}
        />
      )}
      <section
        className={`transition-all duration-500  ease-in-out fixed lg:translate-x-0 lg:w-[18%]  w-[70%]   z-20 ${
          isOpen ? " translate-x-0" : " translate-x-[-1000px]"
        } `}
      >
        {/* <Sidebar /> */}
        <Suspense fallback={<div style={{ padding: 12 }}>Loading...</div>}>
          <NewSideNav />
        </Suspense>
      </section>

      <section
        className={`absolute right-0 ${
          isWorkspace ? "py-0 " : "lg:w-[82%] py-4 px-5"
        } w-full bg-white min-h-full h-fit`}
        onClick={() => dispatch(closeSidebar())}
      >
        <Outlet />
      </section>
    </section>
  );
}
